<script>
export default {
  name: "DidoApidocUsageRoutes",
};
</script>

<script setup>
import { ref, watch } from "vue";
import api from "../../../api";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
});

// define watchers
watch(
  () => props.apiUrl,
  () => refreshUrl(),
);

// define a ref for rapidoc element
const apidoc = ref(null);

// define methods
const refreshUrl = async () => {
  await fetch(api.urlGlobalSwagger(props.apiUrl))
    .then((response) => response.json())
    .then((json) => {
      json.tags = json.tags.map(({ name, description }) => ({
        name,
        description,
        "x-tag-expanded": false,
      }));
      return json;
    })
    .then((spec) => apidoc.value.loadSpec(spec));
};

refreshUrl();
</script>

<template>
  <div class="q-mt-md fit">
    <rapi-doc
      ref="apidoc"
      update-route="false"
      primary-color="#7fc6a4"
      layout="row"
      render-style="view"
      schema-style="tree"
      default-schema-tab="model"
      show-info="false"
      show-header="false"
      allow-server-selection="false"
      allow-authentication="false"
      allow-search="false"
      allow-advanced-search="false"
      allow-try="true"
      schema-description-expanded="true"
      allow-schema-description-expand-toggle="true"
      use-path-in-nav-bar="true"
      regular-font="Marianne"
    />
  </div>
</template>
